import * as THREE from "three";
import { setuprtt } from "../Generator/rtt";
import { generateworldgrid } from "../Generator/worldgrid";
import updateworldgrid from "../Generator/updateworldgrid";

let scene, worldgrid
let tilesize = 10
let camerabox, innercamerabox
let rtt, camera, clock
let target = new THREE.Vector3
let rttobject, renderer
let scrollPercent;

function fullscene(scene, camera) {
  this.scene = scene
  this.camera = camera
}

export default function Mountains(renderer2, loadingmanager, animationScripts) {

  
  function init() {
      const width = window.innerWidth,
        height = window.innerHeight;
      camera = new THREE.PerspectiveCamera(70, width / height, 0.01, 20);
      camera.position.y = 1
      scene = new THREE.Scene();
      worldgrid = generateworldgrid(scene, tilesize)
      camerabox = new THREE.Box3();
      camerabox.setFromCenterAndSize(
        new THREE.Vector3(0, 3, 0),
        new THREE.Vector3(
          tilesize * 5,
          tilesize * 5,
          tilesize * 5
        )
      );
      clock = new THREE.Clock();
      innercamerabox = new THREE.Box3();
      innercamerabox.setFromCenterAndSize(
        camera.localToWorld(target),
        new THREE.Vector3(1, 1, 1)
      );
      renderer = new THREE.WebGLRenderer({ antialias: true });
      renderer.setSize( window.innerWidth, window.innerHeight );
      const light = new THREE.AmbientLight( 0x404040,50 );
      scene.add(light)
      rttobject = setuprtt(tilesize)
  }
        function lerp(x, y, a) {
        return (1 - a) * x + a * y;
      }
  
      // Used to fit the lerps to start and end at specific scrolling percentages
      function scalePercent(start, end) {
        return (scrollPercent - start) / (end - start);
      }

  animationScripts.push({
    start: 0,
    end: 45,

    func: () => {
      const delta = clock.getDelta();
      camera.position.z += -0.01
      


    },
    
  });
  animationScripts.push({
    start: 0,
    end: 100,

    func: () => {
      scrollPercent =
        ((document.documentElement.scrollTop || document.body.scrollTop) /
          ((document.documentElement.scrollHeight ||
            document.body.scrollHeight) -
            document.documentElement.clientHeight)) *
        100;
  

    },
    
  });

  

  function animate() {
  
    requestAnimationFrame(animate);


    camerabox.setFromCenterAndSize(
      new THREE.Vector3(
        camera.position.x,
        camera.position.y,
        camera.position.z 
      ),
      new THREE.Vector3(
        tilesize * 5,
        tilesize * 5,
        tilesize * 5
      )
    );
    innercamerabox.setFromCenterAndSize(
      camera.position,
      new THREE.Vector3(1, 1, 1)
    );
    updateworldgrid(worldgrid, camerabox, tilesize, scene, innercamerabox, renderer2)

  }




  init()
  animate()
  let block = new fullscene(scene,camera)
  return block

}